import {
  BranchesUrl,
  CompaniesUrl,
  DeparetmentsUrl,
  PartnersUrl,
  ProjectExecutorsUrl,
  ProjectOwnersUrl,
} from '@/variables/Urls';

import { Country, State } from './CountryService';
import api from '@/utils/api';
import { AxiosResponse } from 'axios';
import { getCompanyId } from './AuthService';
import { Departement } from './DepartementService';

export interface ProjectExecutor {
  name: string;
  id: string;
  companyId?: string;
}

export interface ProjectExecutorsResponse {
  projectExecutorMOEs: ProjectExecutor[];
  count: number;
}
const apiEndpoint = ProjectExecutorsUrl;

export interface PaginatingParmas {
  takevalue?: number;
  fromvalue?: number;
  search?: string;
}
export async function getProjectExecutors({
  fromvalue = 0,
  takevalue = 10,
  search = '',
}: PaginatingParmas) {
  let config = {
    params: {
      page: fromvalue,
      take: takevalue,
      search: search,
      companyId: getCompanyId(),
    },
  };
  const { data } = await api.get(apiEndpoint + '/Get', config);
  return data as ProjectExecutorsResponse;
}

export async function getProjectExecutor(Id: string) {
  const { data } = await api.get<ProjectExecutor>(apiEndpoint + '/GetById', {
    params: { id: Id },
  });

  return data;
}

export async function saveProjectExecutor(projectExecutor: ProjectExecutor) {
  if (projectExecutor.id) {
    const body = { ...projectExecutor };

    const response = await api.put(apiEndpoint + '/put', body);
    return response;
  }

  const response_1 = await api.post(apiEndpoint + '/post', projectExecutor);
  return response_1;
}

export function deleteProjectExecutor(Id: string) {
  return api
    .delete(apiEndpoint + '/delete', { data: { id: Id } })
    .then((responce) => {
      return responce;
    })
    .catch((error) => {
      return error;
    });
}
